<nb-card accent="info">
    <nb-card-header>
        Proses Absensi
    </nb-card-header>
    <nb-card-body>
        <!-- <p>Lokasi : {{ coordinates.latitude }}, {{ coordinates.longitude }}</p> -->
        <!-- <div class="datetime">
            <nb-icon icon="clock-outline" status="primary"></nb-icon>
            {{ dateandtime }}
        </div>
        <div class="coordinates">
            <nb-icon icon="pin-outline" status="danger"></nb-icon>
            {{ coordinates.latitude }}, {{ coordinates.longitude }}
        </div> -->
        <div> 
            Lanjutkan proses pencatatan absensi ?
        </div>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton (click)="close()">
            Batal ( {{countDown}} )
        </button>
        <button nbButton status="success" (click)="proceed()">
            Lanjut
        </button>
    </nb-card-footer>
</nb-card>
